import { cn } from "@/lib/utils";

import type { QuestionRendererProps } from "../types";

const SPACING_CLASS: Record<"sm" | "md" | "lg", string> = {
  sm: "py-2",
  md: "py-4",
  lg: "py-8",
};

export const DividerQuestion = ({ question }: QuestionRendererProps<null>) => {
  if (question.type !== "divider") {
    return null;
  }

  const spacing = question.spacing ?? "md";

  if (question.style === "spacer") {
    return <div className={cn("w-full", SPACING_CLASS[spacing])} />;
  }

  return (
    <div className={cn("w-full", SPACING_CLASS[spacing])}>
      <hr className="border-border/70" />
    </div>
  );
};
